import React, { Component } from 'react';
import { connect }          from 'react-redux';
import Lightbox                 from 'react-images';
import { SetByResponderQuestao, 
         GetByQuestoesDuelo }   from '../../../../actions/questaoActions';
import { SetError }             from '../../../../actions/authenticActions';

class batalha_jogo_inicio extends Component {

    constructor(props){

        super(props);
        this.state = {
                      qtd_progress           : this.props.allQuestaoJogo.due_ultima_questao+1,
                      usu_id                 : this.props.session.id,
                      due_id                 : this.props.allQuestaoJogo.due_res_cod_duelo,
                      btnActionTexto         : 'Responder',
                      btnActionFunc          : 'handleSubmit',
                      feedbackCentro         : 'battle-alternatives-feedback-neutro',
                      formInputA             :'',
                      formInputB             : '',
                      formInputC             : '',
                      formInputD             : '',
                      lightboxIsOpen        : false,
                      finalizado            : false,
                      showModal             : false,
                      selectButtonResponder : false,
                      txtButton             : "Selecionar",
                      disabledButton        : false,
                      statusAction          : 1,
                      limite                : 3
                    };
         
    }

    renderQuestaoDuelo(){
        this.props.GetByQuestoesDuelo(this.state.usu_id,this.state.due_id).then((response)=>{
           this.setState({load:true,statusAction:1, qtd_progress: this.props.allQuestaoJogo.due_ultima_questao+1});
       })
    }

    checkActionForm(form,action){
        ["A","B","C","D"].map((elem,i)=>{
            if(elem === form){                
                this.setState({feedbackCentro: (action ==0 ? "battle-alternatives-feedback-error" :"battle-alternatives-feedback-success"),
                        [`formInput${elem}`] : (action ==0 ? "battle-alternative-error" :"battle-alternative-success")
                    });
            }else{
                if (form =="reset") {
                    this.setState({feedbackCentro:"battle-alternatives-feedback-neutro",
                    txtButton             : "Selecionar",
                    selectButtonResponder             : false,
                    [`formInput${elem}`] : ""
                 });                    
                }
                document.getElementsByClassName("battle")[0].reset();              
            }
        });
    }

    saveResponderQuestao(){

        this.props.SetByResponderQuestao(this.state.usu_id,
                                        this.state.due_id,
                                        this.props.allQuestaoJogo.due_res_id,
                                        this.props.allQuestaoJogo.due_que_id,
                                        this.state.selectResposta)
        .then((response) => {     
            
                this.checkActionForm(this.state.selectResposta,response.data.acertou);
            
                if(this.state.qtd_progress<=this.state.limite-1){
                    //Buscar nova pergundata   
                    this.setState({statusAction:2,disabledButton:false,txtButton:"Avançar"});                    
                }else{
                    //Encerrar a batalhar e enviar o usuário para a tela de resultado
                    this.setState({statusAction:3,disabledButton:false,txtButton:"Encerrar"});
                }
    
        }).catch((error)=>{
            this.props.SetError(500);
        });
    
     } 


     handleSubmit(e){       
        e.preventDefault();   

        switch(this.state.statusAction) {
            case 1:             
                this.setState({disabledButton: true, txtButton: "Enviando..."});
                this.saveResponderQuestao();
            break;
            case 2:
          
               this.checkActionForm("reset",3);  
               this.renderQuestaoDuelo();
            break;
            case 3:
                window.location.reload()
            break;
            default:
            break;
        }
    }

    selectionResposta(e){      
     this.setState({selectResposta: e.target.value, selectButtonResponder: true});
    }

    render(){
      
        const questao = this.props.allQuestaoJogo;
        return (
           <form className="battle" onSubmit={this.handleSubmit.bind(this)}>
                        <div className="battle-title">
                            <div className="battle-title-info">
                                <div className="battle-title-progress">
                                    <i className="gamefica-icon gamefica-double-angle-right primary"></i> {`${this.state.qtd_progress}/${this.state.limite}`}
                                </div>
                                <div className="battle-title-squares">
                                    {[0,1,2].map((elem,i)=>{return  <div className="battle-title-square battle-title-square-active" key={i}></div>;})}
                                </div>
                            </div>
                            <div className="battle-title-text">
                             {questao.due_que_pergunta}
                            </div>
                        </div>
                        <div className="battle-alternatives">
                            <div className="battle-alternative-container">
                                <input type="radio" value="A" id="ID_A" name="alternativa" onClick={this.selectionResposta.bind(this)}/>
                                <label htmlFor="ID_A" className={`battle-alternative ${this.state.formInputA}`}>
                                    <span className="battle-alternative-label">A</span>
                                    <span className="battle-alternative-text">
                                       {questao.due_que_opcao_a}
                                    </span>
                                </label>
                            </div>
                            <div className="battle-alternative-container">
                                <input type="radio" value="B" id="ID_B" name="alternativa" onClick={this.selectionResposta.bind(this)} />
                                <label htmlFor="ID_B" className={`battle-alternative ${this.state.formInputB}`}>
                                    <span className="battle-alternative-label">B</span>
                                    <span className="battle-alternative-text">
                                       {questao.due_que_opcao_b}
                                    </span>
                                </label>
                            </div>
                            <div className="battle-alternative-container">
                                <input type="radio" value="C" id="ID_C" name="alternativa" onClick={this.selectionResposta.bind(this)} />
                                <label htmlFor="ID_C" className={`battle-alternative ${this.state.formInputC}`}>
                                    <span className="battle-alternative-label">C</span>
                                    <span className="battle-alternative-text">
                                       {questao.due_que_opcao_c}
                                    </span>
                                </label>
                            </div>
                            <div className="battle-alternative-container">
                                <input type="radio" value="D" id="ID_D" name="alternativa" onClick={this.selectionResposta.bind(this)}/>
                                <label htmlFor="ID_D" className={`battle-alternative ${this.state.formInputD}`}>
                                    <span className="battle-alternative-label">D</span>
                                    <span className="battle-alternative-text">
                                       {questao.due_que_opcao_d}
                                    </span>
                                </label>
                            </div>
                            <div className={`battle-alternatives-feedback ${this.state.feedbackCentro}`}>
                                <svg><circle cx="50%" cy="50%" r="50%"></circle></svg>
                            </div>
                        </div>
                        <div className="battle-action">
                            {this.state.selectButtonResponder ? <button type="submit" disabled={this.state.disabledButton} className="action action-big action-long">{this.state.txtButton}</button>:""}
                        </div>
                    </form>
        );
    }
}

function mapStateToProps(state) {

    return { 
            session        : state.auth.session,
            menu           : state.configReducer.menu,
            allQuestaoJogo : state.questaoReducer.allQuestaoJogo,
           }
}

export default connect(mapStateToProps,{
                                         SetByResponderQuestao, 
                                         GetByQuestoesDuelo
                                        })(batalha_jogo_inicio);




// WEBPACK FOOTER //
// ./src/components/aluno/batalha/jogo/batalha_jogo_inicio.js